import { CUSTOMER_STORIES_HOME, PRODUCT_TOUR_PAGE, RESOURCES_HOME } from "@/constants/routes";
import gtm from "@/lib/gtm";
import Link from "next/link";
import { ButtonElement } from "../Button";

export type SelfServeLinksProps = {
  onClose?: () => void;
}

export const SelfServeLinks = ({ onClose }: SelfServeLinksProps) => {
  return (
    <ul className="flex flex-col gap-y-s">
      <li>
        <Link
          href={PRODUCT_TOUR_PAGE}
          onClick={() => {
            onClose?.();
            gtm.track('click', {
              element_type: 'link',
              element_label: 'Explore our product tour',
              location: `Form Success - Demo Modal`,
            });
          }}>
          <ButtonElement
            variant="tertiary"
            className="p-0"
            text="Explore our product tour"
          />
        </Link >
      </li >

      <li>
        <Link href={RESOURCES_HOME}
          onClick={() => {
            onClose?.();
            gtm.track('click', {
              element_type: 'link',
              element_label: 'Check out our resource hub',
              location: `Form Success - Demo Modal`,
            });
          }}>
          <ButtonElement
            className="p-0"
            variant="tertiary"
            text="Check out our resource hub"
          />
        </Link>
      </li>

      <li>
        <Link href={CUSTOMER_STORIES_HOME}
          onClick={() => {
            onClose?.();
            gtm.track('click', {
              element_type: 'link',
              element_label: 'Meet our customers',
              location: `Form Success - Demo Modal`,
            });
          }}>
          <ButtonElement
            variant="tertiary"
            text="Meet our customers"
            className="p-0"
          />
        </Link>
      </li >
    </ul >
  )
}
